import React from 'react';

import { error } from './error.module.scss';

interface Props {
    className?: '';
}

const Error: React.FC<Props> = ({ children, className = '' }) => {
    return <p className={`${error} ${className}`}>{children}</p>;
};

export default Error;
